<template>
  <vk-modal v-if ="userTypeModalOpen" @close="userTypeModalOpen = false">
    <div class="bg-white BODY">
      <vk-modal-header class="text-bold  c-depot"/>
      <vk-modal-content class="m-4 text-center text-black">
        <header-logo dark />
        <br>
        <h2>Hello there!
          <br>
          <span class="TEXT-REGULAR">How can we help you get started with Pro Referral?</span>
        </h2>
        <div class="d-flex fd-column:mo BUTTONS-SECTION">
          <button
              class="btn-secondary w-100:mo m-b-3:mo"
              type="button"
              @click="onSelectCustomer">
            Hire a Pro
          </button>
          <button
              class="btn-secondary w-100:mo"
              type="button"
              @click="onSelectPro">
            I'm a Pro
          </button>
        </div>
      </vk-modal-content>
    </div>
  </vk-modal>
</template>
<script>
import Storage from '@homeservices/tool-kit/storage/local-storage';
import HeaderLogo from '@/layouts/components/HeaderLogo';

const USER_TYPE = 'USER_TYPE_VALUE';
export default {
  name: 'customer-pro-modal',
  components: {
    HeaderLogo,
  },
  data () {
    return {
      userType: Storage.get(USER_TYPE) || '',
      userTypeModalOpen: false,
    };
  },
  mounted () {
    const userType = Storage.get(USER_TYPE);
    const currentRouteName = this.$route.name;
    const userIsLogged = this.$store.getters['user/isLoggedIn'];
    switch (userType) {
      case 'PRO_USER':
        if (currentRouteName !== 'pro-homepage' && !userIsLogged) {
          this.$router.push({
            name: 'pro-homepage',
          });
        }
        break;
      case 'CUSTOMER_USER':
        if (currentRouteName !== 'homepage' && !userIsLogged) {
          this.$router.push({
            name: 'homepage',
          });
        }
        break;
      default:
        this.userTypeModalOpen = true;
        break;
    }
  },
  methods: {
    onSelectPro () {
      Storage.set(USER_TYPE, 'PRO_USER');
      this.userTypeModalOpen = false;
      this.$router.push({
        name: 'pro-homepage',
      });
    },
    onSelectCustomer () {
      Storage.set(USER_TYPE, 'CUSTOMER_USER');
      this.userTypeModalOpen = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .BUTTONS-SECTION{
    justify-content: space-between;
    padding: 36px;
    .btn-secondary{
      width: 30%;
    }
  }
  .TEXT-REGULAR{
    font-weight: 400;
  }
  .BODY{
    @media screen and (min-width: 768px){
      width: 55%;
    }
  }
  .MODAL-LOGO{
    svg{
      color: black !important;
    }
  }
</style>
